module.exports = __webpack_public_path__ + "img/ava1.02e100ef.png";